export enum OccupationKeyEnum {
  DEFAULT = 'default',
  SPECIALIST = 'specialist',
  STUDENT = 'student',
  OTHER_PROFESSIONS = 'other-professions',
}

export type AuthIntroProps = {
  occupationKey: OccupationKeyEnum;
  legacyMode?: boolean;
};
